const calculateWidth = (kind, width) => {
    // default value
    if (!width)
        return kind === 'expanded' ? 'auto' : '100%';
    // if width configured
    if (kind === 'expanded') {
        return width === '100%' ? '100%' : 'auto';
    }
    return width;
};

export { calculateWidth };
